import { takeLatest, fork, put, select, race, take, delay } from 'redux-saga/effects';
import type { Action } from 'redux-actions';

import { statisticActions } from '../../../actions/statistics/statisticActions.ts';
import { postDialogStatistics } from 'app/actions/dasboard/dashboardActions.ts';
import type { AddDialogStatisticCommand } from '@/api-gen/api.schemas';
import * as DialogProcessorSelectors from 'app/selectors/dialogProcessorSelector.ts';
import { DialogProcessorActions } from 'app/actions/dialogprocessor/dialogProcessorActions.ts';
import { ScenarioChartStoreActions } from 'app/actions/scenarios/scenarioChartStoreAction.ts';
import logger from 'app/utils/logger.ts';

function* stopStatistic(params: Action<AddDialogStatisticCommand>) {
  const sessionId = yield select(DialogProcessorSelectors.sessionIdSelector);

  try {
    if (sessionId) {
      // Only post statistics if we have a valid sessionId
      yield put(
        postDialogStatistics({
          sessionId,
          ...params.payload
        })
      );

      // Wait for success or failure only if we attempted to post
      const { success, failure } = yield race({
        success: take(statisticActions.Type.POST_DIALOG_STATISTICS_SUCCESS),
        failure: take(statisticActions.Type.POST_DIALOG_STATISTICS_FAILURE),
        timeout: delay(10000)
      });

      if (failure) {
        logger.warn('Dialog statistics post failed. Session was reset anyway.');
      }
    } else {
      logger.warn('Skipped posting dialog statistics due to null sessionId');
    }

    // These cleanup operations happen regardless of sessionId
    yield put(ScenarioChartStoreActions.resetIsDialogProcessOnTheNode());
    yield put(DialogProcessorActions.setSessionId(null));
  } catch (error) {
    logger.log('Error getDPResponse in stopStatistic: ', error);
  }
}

function* watchPostStatistic() {
  yield takeLatest(statisticActions.Type.POST_STATISTICS, stopStatistic);
}

export default function* watchAllStatisticSaga() {
  yield fork(watchPostStatistic);
}
